<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
    <div style="border: 1px solid #e9e9e9; padding: 11px; min-height: 220px;">
        <b-loading :is-full-page="loader.isFullPage" :active.sync="loader.isLoading" :can-cancel="false"></b-loading>
        <div class="columns">
            <div class="column is-6">
                <multiselect
                        v-model="value"
                        track-by="id"
                        label="name"
                        placeholder="Select one"
                        :options="filterZohoProducts"
                        :searchable="true"
                        :allow-empty="true">
                    <template
                            slot="singleLabel"
                            slot-scope="{ product }">
                        {{ value.name}}
                    </template>
                </multiselect>
            </div>
            <div class="column is-auto">
                <div class="buttons">
                    <b-button type="is-info" v-on:click="addProduct" outlined>Add product</b-button>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-6">
                <div class="table-wrapper">
                    <table class="table" style="width: 100%;">
                        <tbody>
                        <tr v-for="productId in selectedProducts">
                            <td>{{getProductNameById(productId)}}</td>
                            <td class="has-text-right">
                                <b-button
                                        type="is-danger"
                                        outlined
                                        size="is-small"
                                        v-on:click="deleteProduct(productId)"
                                >Delete
                                </b-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <b-button
                        outlined
                        type="is-info"
                        v-if="shouldSaveButtonDisplay"
                        v-on:click="save">
                    Save
                </b-button>

            </div>
        </div>
    </div>

</template>

<script>
  import LayoutBasic from '@/layouts/LayoutBasic'
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'product_set',
    components: {
      LayoutBasic,
      Multiselect
    },
    data () {
      return {
        loader: {
          isFullPage: true,
          isLoading: true,
        },
        productSetId: null,
        selectedProducts: [],
        zohoProducts: [],
        value: null
      }
    },

    computed: {
      filterZohoProducts () {
        return this.zohoProducts.filter(product => {
          return this.selectedProducts.indexOf(product.id) === -1;
        });
      },
      shouldSaveButtonDisplay() {
        return this.selectedProducts.length > 0
      }
    },

    methods: {
      addProduct () {
        if (this.value) {
          this.selectedProducts.push(this.value.id)
          this.value = null
        }
      },

      deleteProduct (id) {
        const index = this.selectedProducts.indexOf(id)
        if (index !== -1) {
          this.selectedProducts.splice(index, 1)
        }
      },

      getProductNameById (id) {
        for (let product in this.zohoProducts) {
          if (this.zohoProducts[product].id == id) {
            return this.zohoProducts[product].name
          }
        }

        return ''
      },

      getZohoProducts () {
        this.zohoProducts = [];
        let thisScope = this;
        ZOHO.CRM.API.getAllRecords({ Entity: 'Products', sort_order: 'asc', per_page: 10000, page: 1 })
          .then(function (response) {
            response.data.forEach(function (product) {
              thisScope.zohoProducts.push({
                'id': product.id,
                'name': product.Product_Name
              })
            });
            thisScope.getProductSet()
          }).catch(function (err) {
            console.log(err)
          }).finally(function () {
            thisScope.loader.isLoading = false;
          })
      },

      save () {
        let thisScope = this;

        if (this.productSetId) {
          this.loader.isLoading = true;
          let data = {
            zoho_product_set_id: this.productSetId,
            products: this.selectedProducts
          }

          axios.post('/product-set/save', data)
            .then(function () {
              thisScope.$toast.open({
                message: 'Successfully saved.',
                type: 'is-success'
              });
            })
            .catch(function (error) {
              console.log(error)
            }).finally(function () {
              thisScope.loader.isLoading = false;
            })
        }
      },

      getProductSet () {
        let scope = this
        axios.post('/product-set/get', { zoho_product_set_id: this.productSetId })
          .then(function (response) {
            const responseData = response.data
            scope.selectedProducts = responseData.products.filter(function (productId) {
              for (const product in scope.zohoProducts) {
                if (scope.zohoProducts[product].id == productId) {
                  return true;
                }
              }

              return false
            })
          })
      }
    },

    created () {
      let scope = this
      ZOHO.embeddedApp.on('PageLoad', function (data) {
        scope.productSetId = data.EntityId
        scope.getZohoProducts()
      })

      ZOHO.embeddedApp.init()
    },
  }
</script>
